/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Left } from 'purify-ts';
import { NonEmptyList } from '@codegrade/non-empty-list';
import { BaseAutoTestStep } from './base';
import { errOrData, mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class CodeQualityAutoTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave() {
        const base = this._baseGetDataToSave();
        let errs = [];
        const wrapper = this.data.wrapper;
        if (wrapper == null) {
            const existing = base
                .mapLeft(baseErrs => [...baseErrs, ...errs])
                .swap()
                .orDefault([]);
            const res = NonEmptyList(['Please select a wrapper']).concat(existing);
            return Left(res);
        }
        else if (wrapper === 'custom') {
            errs = errs.concat(this._checkProgramNotEmpty());
        }
        const extra = errOrData(errs, { type: this.type, data: { ...this.data, wrapper } });
        return mergeEithers(base, extra);
    }
}
